import $ from 'jquery';
import BlogLayout from '../snippets/BlogLayout';

export default class DynamicBlogPosts {
  constructor(section) {
    this.$el = $(section.el);

    // Articles
    this.$articles = $('[data-article-excerpts]', section.el);
    this.blogLayout = new BlogLayout(this.$articles, {
      flickity: true,
    });
  }

  onSectionUnload() {
    this.blogLayout.unload();
  }
}
